// Mock data for TechyHive

export const services = [
  {
    id: 1,
    title: "Implementation Papers",
    description: "Complete implementation papers with code, analysis, and documentation for your college projects.",
    icon: "Code"
  },
  {
    id: 2,
    title: "Survey Papers",
    description: "Comprehensive survey papers covering latest trends and research in your domain.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Project Code",
    description: "Production-ready project code with proper documentation and implementation guide.",
    icon: "Terminal"
  },
  {
    id: 4,
    title: "Reports & Documentation",
    description: "Professional project reports with complete documentation and presentation support.",
    icon: "BookOpen"
  },
  {
    id: 5,
    title: "Portfolio Development",
    description: "Create stunning portfolios to showcase your projects and skills.",
    icon: "Briefcase"
  },
  {
    id: 6,
    title: "Custom Solutions",
    description: "Tailored solutions for your specific project requirements across all CS domains.",
    icon: "Sparkles"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mohammed Ahmed",
    role: "Computer Science Student",
    content: "TechyHive delivered my machine learning project ahead of schedule. The code quality and documentation were exceptional!",
    rating: 5
  },
  {
    id: 2,
    name: "Rahul Verma",
    role: "IT Engineering Student",
    content: "Got my blockchain implementation paper done perfectly. The team understood my requirements and delivered beyond expectations.",
    rating: 5
  },
  {
    id: 3,
    name: "Ananya Patel",
    role: "Final Year Student",
    content: "Amazing service! They helped me with my final year project and portfolio. Highly recommended for all CS students.",
    rating: 5
  },
  {
    id: 4,
    name: "Arjun Singh",
    role: "MCA Student",
    content: "Outstanding work on my web development project! The code was clean, well-documented, and exactly what I needed for my presentation.",
    rating: 5
  },
  {
    id: 5,
    name: "Sneha Reddy",
    role: "B.Tech CSE",
    content: "They helped me with my IoT project and survey paper. Professional service with timely delivery. Will definitely use again!",
    rating: 5
  },
  {
    id: 6,
    name: "Vikram Kumar",
    role: "Computer Engineering",
    content: "The AI implementation they provided was top-notch. Great communication throughout the project and excellent final results.",
    rating: 5
  },
  {
    id: 7,
    name: "Parveez Sulthana",
    role: "Information Technology",
    content: "Perfect solution for my cloud computing project. The team was very responsive and made all the changes I requested promptly.",
    rating: 5
  },
  {
    id: 8,
    name: "Aditya Mishra",
    role: "Software Engineering",
    content: "Excellent work on my data science project! The analysis was thorough and the visualization were impressive. Highly professional!",
    rating: 5
  },
  {
    id: 9,
    name: "Ishita Joshi",
    role: "CS Final Year",
    content: "Got my cybersecurity implementation paper done with complete code and documentation. Best decision for my final year project!",
    rating: 5
  }
];

export const projectTypes = [
  "Implementation Paper",
  "Survey Paper",
  "Project Code",
  "Report",
  "Portfolio",
  "Custom Project"
];

export const domains = [
  "Machine Learning",
  "Artificial Intelligence",
  "Blockchain",
  "Web Development",
  "Mobile Development",
  "Cloud Computing",
  "Cybersecurity",
  "Data Science",
  "IoT",
  "Computer Vision",
  "Natural Language Processing",
  "Other"
];
